import { render, staticRenderFns } from "./SortCostIcon.vue?vue&type=template&id=a8cf36c2&"
import script from "./SortCostIcon.vue?vue&type=script&lang=js&"
export * from "./SortCostIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports